<div class="container h-100 pt-5">
    <div class="row h-100 justify-content-center align-items-center">
        <div class="p-0 p-sm-5 form-container d-flex flex-column rounded-lg">
            <ng-container *ngIf="customizations$ | async as customizations">
                <div class="d-flex justify-content-center">
                    <p-image src="{{ 'data:image/png;base64,' + customizations.logoData }}" alt="Logo" *ngIf="!!customizations.logoData"></p-image>
                    <p-image src="../../assets/image/sf-fitness-logo_login.png" alt="Logo" width="250" *ngIf="!customizations.logoData"></p-image>
                </div>
            </ng-container>

            <div class="p-3 d-flex flex-column" *ngIf="!isPasswordReset" style="max-width: 350px">
                <div class="pt-4">
                    <small class="text-muted">{{ 'AUTHENTICATION.RESET_PASSWORD.INFO' | translate }}</small>
                </div>
                <div class="pt-3">
                    <form [formGroup]="passwordResetForm">
                        <div class="form-group w-100">
                            <div class="p-input-icon-left w-100">
                                <i class="pi pi-envelope"></i>
                                <input type="text" pInputText formControlName="email" class="w-100" required />
                            </div>
                            <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" style="font-size: small" class="text-danger pt-1">
                                <div *ngIf="email?.errors?.['required']">{{ 'VALIDATION_EMAIL' | translate }}</div>
                                <div *ngIf="email?.errors?.['email']">{{ 'VALIDATION_EMAIL' | translate }}</div>
                            </div>
                        </div>
                        <div class="form-group w-100">
                            <button class="btn btn-primary btn-block" (click)="submitPasswordReset()">
                                {{ 'AUTHENTICATION.RESET_PASSWORD.BUTTON_RESET' | translate }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div *ngIf="isPasswordReset" class="p-3 d-flex flex-column pt-4">
                <div>
                    <small class="text-muted">{{ 'AUTHENTICATION.RESET_PASSWORD.SENT_INFO' | translate }}</small>
                </div>
                <div class="pt-2">
                    <small class="text-muted">{{ 'AUTHENTICATION.RESET_PASSWORD.SENT_SPAM' | translate }}</small>
                </div>
            </div>
            <div class="w-100 d-flex justify-content-center pb-3">
                <a class="link-primary" routerLink="/auth/sign-in">
                    <small class="form-text">{{ 'AUTHENTICATION.BUTTON_BACK_TO_LOGIN' | translate }}</small>
                </a>
            </div>
        </div>
    </div>
</div>
